module.exports = __webpack_public_path__ + "static/media/2.1e75fcd5.png";